import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    typingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 2),
        marginBottom: theme.spacing(1),
    },
    typingText: {
        fontSize: '0.875rem',
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
    dotsContainer: {
        display: 'flex',
        gap: '4px',
    },
    dot: {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: theme.palette.text.secondary,
        animation: '$typing 1.4s infinite ease-in-out',
        '&:nth-child(1)': {
            animationDelay: '0s',
        },
        '&:nth-child(2)': {
            animationDelay: '0.2s',
        },
        '&:nth-child(3)': {
            animationDelay: '0.4s',
        },
    },
    '@keyframes typing': {
        '0%, 60%, 100%': {
            transform: 'translateY(0)',
            opacity: 0.4,
        },
        '30%': {
            transform: 'translateY(-10px)',
            opacity: 1,
        },
    },
}));



const TypingIndicator: React.FC<any> = () => {
    const classes = useStyles();

    return (
        <Box className={classes.typingContainer}>

            <Box className={classes.dotsContainer}>
                <Box className={classes.dot} />
                <Box className={classes.dot} />
                <Box className={classes.dot} />
            </Box>
        </Box>
    );
};

export default TypingIndicator;
